export type ListPriceRequestMessages = {
  // Success Messages
  activateListPriceSuccess: string;
  listPriceUpdateSuccess: string;

  // Error Messages
  listPriceErrorToLoad: string;
  listPriceNotFoundDescription: string;
  listPriceNotFoundError: string;
};

export const LIST_PRICE_REQUEST_MESSAGES: ListPriceRequestMessages = {
  // Success Messages
  activateListPriceSuccess: "Status do produto alterado com sucesso.",
  listPriceUpdateSuccess: "Preço atualizado com sucesso.",

  // Error Messages
  listPriceErrorToLoad: "Erro ao carregar os preços.",
  listPriceNotFoundDescription: "Não conseguimos encontrar o preço que você está procurando",
  listPriceNotFoundError: "Preço não encontrado",
};
